var Curriculog = Curriculog || {};

Curriculog.EmptyStepFilter = (function ($, _, Backbone, EmptyStepFilter) {

	EmptyStepFilter = Backbone.View.extend({

		el: function () {
			return $('#report-9-empty');
		},

		events: {
			'click': 'evaluate',
		},

		initialize: function(options) {
			this.params = options.params;
			this.defaultQueries = options.defaultQueries;
			this.listenTo(Backbone, 'decision:on', this._disable);
			this.listenTo(Backbone, 'decision:off', this._enable);
		},

		get: function() {
			var emptyFilter = this.params.queryParams.get('empty');
			if (parseInt(emptyFilter) === 1) {
				this.$el.attr('checked', true);
			} else {
				this.$el.attr('checked', false);
			}
			this.disable();
		},

		set: function() {
			var empty = (this.$el.is(':checked')) ? 1 : 0;
			this.params.queryParams.set('empty', empty);
		},

		disable: function(event) {
			// disables checkbox if not available by default in the base query
			var allowedEmpty = this.defaultQueries[this.params.domParams.get('tab')].allowedEmpty();

			this.$el.attr('disabled', false);
			if (! allowedEmpty) {
				this._disable();
			}
		},

		_disable: function() {
			// disables checkbox
			this.$el.attr('disabled', true);
		},

		_enable: function() {
			// enables checkbox
			this.$el.attr('disabled', false);
		},

		evaluate: function() {
			// checks if the field is on, and fires an event to disable 
			// mutually exclusive advanced filter options
			if (this.params.domParams.get('tab') === 'completed') {
				// in completed filter, this isn't applicable
				return;
			}

			if (this.$el.is(':checked')) {
				Backbone.trigger('empty:on');
			} else {
				Backbone.trigger('empty:off');
			}
		}

	});

	return EmptyStepFilter;

})($, _, Backbone, Curriculog.EmptyStepFilter || {});


